import { request } from "../util/Request";

export async function getAllTasks() {
  const response = await request("/api/Task/GetAll");
  console.log(response);
  return await response.json();
}
